import type { Router } from 'vue-router'
import { useProjectStore } from '@/stores/project'

const SESSION_ROUTE_NAMES = new Set(['workspace', 'editor', 'focus', 'preview3d', 'palette'])

function isSessionRoute(name: unknown) {
  return typeof name === 'string' && SESSION_ROUTE_NAMES.has(name)
}

export function installUnsavedGuard(router: Router) {
  router.beforeEach((to, from) => {
    if (!from.name || !isSessionRoute(from.name) || isSessionRoute(to.name)) return true
    const project = useProjectStore()
    if (!project.dirty) return true
    return window.confirm('当前项目有未保存的修改，确定离开？')
  })

  window.addEventListener('beforeunload', (event) => {
    const project = useProjectStore()
    if (!project.dirty) return
    event.preventDefault()
    event.returnValue = ''
  })
}
